
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/diamondhead/privacy-policy",
      function () {
        return require("private-next-pages/diamondhead/privacy-policy.js");
      }
    ]);
  